import { ColumnDataTypeEnum } from "../tsmodels/FilterModel";
import { ReactComponent as ArrowIcon } from "../images/table-arrow.svg";
import { ReactComponent as DeleteIcon } from "../images/delete.svg";
import { getPercentage } from "../helpers/GenericHelpers";
import Appservice from "../services/appservice";

  ///Delete documents  
  const service = new Appservice()

  const deleteDocStatus = (event:any,row:any) =>{
   event.stopPropagation();
    const payLoad = {
      status: "Deleted",
      docId: row.documentId,
    }
    service.updateDocStatus(payLoad)
    
    
  }

export const questionnaireColumns = [
  {
    columnName: "questionnaireName",
    aliasName: "Questionnaire Name",
    columnDatatype: ColumnDataTypeEnum.STRING,
    width: "35%",
  },
  {
    columnName: "createAt",
    aliasName: "created",
    columnDatatype: ColumnDataTypeEnum.DATE,
  },
  {
    columnName: "lastModifiedAt",
    aliasName: "Last Modified",
    columnDatatype: ColumnDataTypeEnum.DATE,
  },
  {
    columnName: "categories",
    aliasName: "Categories",
    columnDatatype: ColumnDataTypeEnum.NUMBER,
  },
  {
    columnName: "questions",
    aliasName: "Questions",
    columnDatatype: ColumnDataTypeEnum.NUMBER,
  },
  {
    columnName: "documents",
    aliasName: "Documents",
    columnDatatype: ColumnDataTypeEnum.NUMBER,
  },
  {
    aliasName: "arrow",
    columnName: "arrow",
    columnDatatype: ColumnDataTypeEnum.RENDER_HTML,
    formatter: (row: any, column: any, onRowChange: (row: any) => void) => (
      <div className="table-arrow">
        <ArrowIcon />
      </div>
    ),
    disableFunctions: true,
    hideHeader: true,
    width: 40,
  },
];

export const documentColumns = [
  {
    columnName: "documentName",
    aliasName: "Document Name",
    columnDatatype: ColumnDataTypeEnum.STRING,
    width: "30%",
  },
  {
    columnName: "createAt",
    aliasName: "UPLOADED",
    columnDatatype: ColumnDataTypeEnum.DATE,
  },
  {
    columnName: "lastModifiedAt",
    aliasName: "Last Modified",
    columnDatatype: ColumnDataTypeEnum.DATE,
  },
  {
    columnName: "questionnaireName",
    aliasName: "questionnaire",
    columnDatatype: ColumnDataTypeEnum.STRING,
    width: "15%",
  },
  {
    columnName: "verification",
    aliasName: "verification",
    columnDatatype: ColumnDataTypeEnum.RENDER_HTML,
    formatter: (row: any, column: any, onRowChange: (row: any) => void) => (
      <div className="verification-container">
        <div className="verified">
          {row?.verifiedFields}/{row?.totalFields}
        </div>
        <div className="divider"></div>
        <div className="total">{row?.verifiedPercentage ?? 0}%</div>
      </div>
    ),
    customSortFunction: (row1: any, row2: any) => {
      // const row1Percentage = getPercentage(row1?.verifiedFields, row1?.totalFields)
      // const row2Percentage = getPercentage(row2?.verifiedFields, row2?.totalFields)
      return (row1?.verifiedPercentage ?? 0) > (row2?.verifiedPercentage ?? 0)
        ? -1
        : 1;
    },
    width: 200,
  },
  {
    columnName: "delete",
    aliasName:"delete",
    columnDatatype: ColumnDataTypeEnum.RENDER_HTML,
    formatter: (row: any, column: any, onRowChange: (row: any) => void) => (
      <div className="table-arrow" onClick = {(e)=>deleteDocStatus(e,row)}>
        <DeleteIcon/>
      </div>
    ),
    disableFunctions: true,
    hideHeader: true,
    width: 20,
  },
  {
    aliasName: "arrow",
    columnName: "arrow",
    columnDatatype: ColumnDataTypeEnum.RENDER_HTML,
    formatter: (row: any, column: any, onRowChange: (row: any) => void) => (
      <div className="table-arrow">
        <ArrowIcon />
      </div>
    ),
    disableFunctions: true,
    hideHeader: true,
    width: 40,
  },
];

export const mappingColumns = [
  {
    columnName: "mappingName",
    aliasName: "Mapping Name",
    columnDatatype: ColumnDataTypeEnum.STRING,
    width: "35%",
  },
  {
    columnName: "createAt",
    aliasName: "created",
    columnDatatype: ColumnDataTypeEnum.DATE,
  },
  {
    columnName: "lastModifiedAt",
    aliasName: "Last Modified",
    columnDatatype: ColumnDataTypeEnum.DATE,
  },
  {
    columnName: "connections",
    aliasName: "connections",
    columnDatatype: ColumnDataTypeEnum.NUMBER,
  },
  {
    columnName: "questionnaireName",
    aliasName: "questionnaire",
    columnDatatype: ColumnDataTypeEnum.STRING,
    width: "20%",
  },
  {
    aliasName: "arrow",
    columnName: "arrow",
    columnDatatype: ColumnDataTypeEnum.RENDER_HTML,
    formatter: (row: any, column: any, onRowChange: (row: any) => void) => (
      <div className="table-arrow">
        <ArrowIcon />
      </div>
    ),
    disableFunctions: true,
    hideHeader: true,
    width: 40,
  },
];
